/* eslint-disable react/prop-types */
import { HeaderMenuButton as CarbonHeaderMenuButton } from '@carbon/react';

export const HeaderMenuButton = ({ children, ...props }) => (
  <CarbonHeaderMenuButton {...props}>{children}</CarbonHeaderMenuButton>
);
